import styled from "styled-components";
import { AccountContentContainer } from "../../../Bookings/components/OverAll/style";
import { colors } from "constants/colors";
import { styleSizes } from "constants/styleSizes";

export const BillingOverAllContentContainer = styled(AccountContentContainer)`
  .accountBody {
    .cardContent {
      .trip {
        .total,
        .card {
          @media (max-width: ${styleSizes.mobileBreakpoint}) {
            display: flex;
            flex-direction: row;
          }
          .modifyCardLink {
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              display: flex;
              flex-direction: row;
              gap: 16px;
            }
          }
          .cardData {
            @media (max-width: ${styleSizes.mobileBreakpoint}) {
              display: flex;
              flex-direction: row;
              gap: 12px;
            }
          }
        }
      }
      .datesMobile {
        display: none;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          display: flex;
          flex-direction: column;
          gap: 16px;

        }
        .datesMobileRow {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .datesMobileLabel {
          font-weight: 600;
          font-size: 16px;
          text-transform: uppercase;
        }
      }
      .dates {
        @media (max-width: ${styleSizes.miniBreakpoint}) {
          display: none !important;
        }
      }
      .primaryBookingCodeTablet {
        color: ${colors.black};
        padding-top: 16px;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          display: none;
        }
      }
      .bookingTableHeader {
        grid-template-columns: 120px 190fr 180fr 120fr 180fr 145px;
        @media (max-width: ${styleSizes.tabletBreakpoint}) {
          grid-template-columns: 110px 130fr 120fr 170fr 145px;
        }
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          grid-template-columns: 110px 130fr 120fr 170fr 145px;
        }
      }

      .bookingTableContent {
        .trip {
          grid-template-columns: 120px 190fr 180fr 120fr 180fr 145px;
          @media (max-width: ${styleSizes.tabletBreakpoint}) {
            grid-template-columns: 110px 130fr 120fr 170fr 145px;
          }
          @media (max-width: ${styleSizes.miniBreakpoint}) {
            grid-template-columns: 110px 130fr 170fr 145px;
          }
          @media (max-width: ${styleSizes.mobileBreakpoint}) {
            grid-template-columns: 1fr;
          }
        }
      }
      .status {
        white-space: nowrap;
      }
      .modifyCardLinkAmount {
        margin-bottom: 12px;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          margin-bottom: 0;
          }
      }
      .modifyCardLinkModify {
        margin-top: 12px;
        @media (max-width: ${styleSizes.mobileBreakpoint}) {
          margin-top: 0;
        }
      }
      .modifyCardLink {
        font-size: 16px;
        font-weight: 400;
        color: ${colors.hoverBlue};
        cursor: pointer;
        text-decoration: underline;
        white-space: nowrap;
      }
      .cardNoLink {
        white-space: nowrap;
      }
      .card {
        text-align: left;
        padding-right: 10px;
      }
    }
  }
`;
